/**
 * 学生花名册
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import './Roster.css';
import {Picker, List, Toast} from 'antd-mobile';
import {fetchGet, fetchPost} from "../../../utils/fetchRequest";
import {API} from "../../../configs/api.config";
import RosterBean from "../../../model/RosterBean";
import {getArrayValue, getIntValue, getStrValue, isObjEmpty} from "../../../utils/common";
import ReactDOM from "react-dom";
import RosterItem from '../../../components/RosterItem';
import {saveClassData} from "../../../redux/actions/classData";
import {saveListState} from "../../../redux/actions/listState";
import ClassBean from '../../../model/ClassBean'
import {Icon} from "antd";

class Roster extends Component {

    constructor() {
        super();
        this.state = {
            curDayData: [],
            classList: [],
            albumList: [],
            classValue: [],
            total: 0,
            count: 0

        }
    }
    componentDidMount() {
        document.title = '学生名单';
        this.container.scrollIntoView();
        this.getClassList()
    }


    render() {
        const {
            albumList, classList, classValue, total, count
        } = this.state;
        let albumItems = []
        if (!isObjEmpty(albumList)) {
            for (let i = 0; i < albumList.length; i++) {
                const albumBean = albumList[i]
                if (!isObjEmpty(albumBean)) {
                    albumItems.push(
                        <RosterItem
                            albumBean={albumBean}
                            itemClick={this.onRosterItemClick.bind(this)}
                            index={i}
                            key={albumBean.stuId}/>
                    )
                }
            }
        }

        return (
            <div ref={node => this.container = node} style={{height: '100vh', overflow: 'scroll'}}>
                <div className='gray-line'></div>
                <Picker data={classList} title='选择班级' extra='请选择'
                        value={classValue} onChange={this.handleClassChange} cols={1}>
                    <List.Item arrow="horizontal">选择班级</List.Item>
                </Picker>
                <div className='gray-line'></div>
                <div style={{textAlign:'center'}}>
                    {total}人，未绑定{count}人
                </div>
                <div className='gray-line' style={{height: '1px'}}></div>
                <div className="header_days_sty">
                <div className={'each_day_default'}>
                    姓名
                </div>
                <div className={'each_day_default'}>
                    家长
                </div>
                <div className={'each_day_default'}>
                    电话
                </div>
                <div className={'each_day_default'}>
                    绑定
                </div>
                </div>

                {/*<div style={{padding: '5px'}}>*/}
                    {albumItems}
                {/*</div>*/}
                {classValue.length>0?(
                <Icon type="plus-circle" theme='filled' className='common-add-icon'
                      onClick={this.onAddRoster}/>
                    ):""}
            </div>
        )
    }

    onAddRoster = () => {
        const {
            classList, classValue
        } = this.state;
        this.props.history.push('/rosterApply/' + classList[classValue].label + '/' + classList[classValue].schId + '/' + this.props.userInfo.user.schoolId)
    }

    getClassList = () => {
        const {classList, classValue} = this.state
        classList.length = 0

        let url = API.GET_SCHOOL_LIST
        let params = {
                schoolId: this.props.userInfo.user.schoolId,
                teacherId: this.props.userInfo.user.userFunId
            }
        fetchGet(url, params).then(response => {
            Toast.hide()
            this.analysisClassList(response)
        }).catch(error => {
            Toast.hide()

            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('班级获取异常', 2)
            }
        })
    }

    analysisClassList = response => {
        const {classList, classValue} = this.state
        classList.length = 0
        classValue.length = 0

        let dataArray = response.data
        if (dataArray) {
            for (let i = 0; i < dataArray.length; i++) {
                let dataObject = dataArray[i]
                if (dataObject) {
                    let classBean = new ClassBean()

                    classBean.label = getStrValue(dataObject, 'gradeName') + getStrValue(dataObject, 'clazzName')
                    classBean.value = i
                    classBean.schId = getStrValue(dataObject, 'clazzId')
                    classBean.parentId = getStrValue(dataObject, 'gradeId')
                    classBean.schName = getStrValue(dataObject, 'clazzName')
                    classBean.schStatus = getStrValue(dataObject, 'clazzStatus')
                    classBean.schRemarks = getStrValue(dataObject, 'clazzRemarks')
                    classBean.grade = getStrValue(dataObject, 'gradeName')

                    classList.push(classBean)
                }
            }

            if (classList.length > 0) {
                classValue.push(classList[0].value)
                this.setState({
                    classList,
                    classValue
                })

                Toast.loading('学生名单...', 0)
                this.getAlbumList(classList[0])
            }
        }
    }

    onRosterItemClick = (index) => {
        const {classList, classValue, albumList} = this.state

        saveClassData({
            classList: classList,
            classValue: classValue,
        })()
        console.log('dd', ReactDOM.findDOMNode(this.container))
        saveListState({
            scrollTop: ReactDOM.findDOMNode(this.container).scrollTop,
        })()
        if (index === 0 && this.mType === 'teacher') {
            let classId = -1
            let classname = ''
            if (classList[classValue]) {
                classId = classList[classValue].schId
                classname = classList[classValue].label
            }
            this.props.history.push('/newAlbum/' + classId + '/' + classname)
        } else {
            this.props.history.push('/pictureList/' + this.mType + '/' + getStrValue(albumList[index], 'albumId')
                + '/' + this.state.albumList[index].albumName)
        }
    }

    handleClassChange = (v) => {
        this.setState({classValue: v})
        if(v.length>0){
            Toast.loading('学生名单...', 0)
            this.getAlbumList(this.state.classList[v])
        }
    }

    getAlbumList = classBean => {
        let count=0;

        fetchPost(API.GET_ROSTER_LIST, {
            clazzId: classBean.schId,
            pageIndex: 1,
            pageSize: 100,
        }).then(response => {
            Toast.hide()

            const rosterList = [];
            let dataArray = response.data
            if (dataArray) {
                let total = dataArray.length;
                for (let i = 0; i < dataArray.length; i++) {
                    let dataObject = dataArray[i]
                    if (dataObject) {
                        let albumBean = new RosterBean()
                        albumBean.stuId = getIntValue(dataObject, 'stuId')
                        albumBean.stuName = getStrValue(dataObject, 'stuName')
                        albumBean.stuBindingState = getIntValue(dataObject, 'stuBindingState')===1?"已绑定":"未绑定"
                        albumBean.parentsList = getArrayValue(dataObject, 'parentsDOS')
                        if(albumBean.stuBindingState==="未绑定"){
                            count++;
                        }

                        rosterList.push(albumBean)
                    }
                }

                this.setState({
                    albumList: rosterList,
                    total: total,
                    count: count
                })
            }
        }).catch(error => {
            Toast.hide()
            if (typeof error === 'string') {
                Toast.fail(error)
            }
        })
    }


    selectDayClick = (value) => {
        debugger
        console.log("value", value)
        var Cdata = null
        if (value === 1) {
            Cdata = this.state.classData.curMons
        } else if (value === 2) {
            Cdata = this.state.classData.curTuess
        } else if (value === 3) {
            Cdata = this.state.classData.curWeds
        } else if (value === 4) {
            Cdata = this.state.classData.curThurs
        } else {
            Cdata = []
        }
        this.setState({
            CurDay: value,
            curDayData: Cdata
        }, function () {
            console.log("curDayData", this.state.curDayData)
        })
    }

}

let mapStateToProps = (state) => ({
    userInfo: {...state.redUserInfo},
    listState: {...state.redListState}
});

let mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Roster)